export const LOGIN_FORM_INIT_VALUES = {
  email: '',
  password: '',
};

export const SIGNUP_FORM_INIT_VALUES = {
  firstName: '',
  lastName: '',
  email: '',
  password: '',
};

export const VERIFY_FORM_INIT_VALUES = {
  email: '',
  confirmationCode: '',
};

export const FORGOT_PASSWORD_INIT_VALUES = {
  email: '',
};

export const RESET_PASSWORD_INIT_VALUES = {
  confirmationCode: '',
  newPassword: '',
};

export const SIGNUP_MAX_CHARS = { maxLength: 30 };

export const PRE_SIGNUP_ERR = 'PreSignUp failed with error ';
